<template>
    <Swiper
            :slides-per-view="swiperSetting.sliderPerView"
            :space-between="swiperSetting.spaceBetween"
            :loop="swiperSetting.loop"
            :breakpoints="swiperSetting.breakpoints"
    >
        <SwiperSlide v-for="slide in swiperSlides" :key="slide">
            <slot name="sliderBody" :slide="slide">
                <template v-if="props.needLink">
                    <NuxtLink :to="slide.link">
                        <Card :title="slide.title" :price="slide.price" :price-old="slide.priceOld"
                              :imgUrl="slide.picture" type="info"/>
                    </NuxtLink>
                </template>
                <template v-else>
                    <Card :title="slide.title" :price="slide.price" :price-old="slide.priceOld" :imgUrl="slide.picture"
                          type="info"/>
                </template>
            </slot>
        </SwiperSlide>
    </Swiper>
</template>

<script setup>
import Card from "~/components/UI/Card/Card.vue";

const props = defineProps({
    swiperClass: {type: String, default: ""},
    slideClass: {type: String, default: ""},
    slideImageClass: {type: String, default: ""},
    /**
     * @type {SwiperImg[]}
     */
    swiperSlides: {type: Array, required: true},
    needLink: {type: Boolean, default: false},
    swiperSetting: {
        type: Object,
        default: (() => {
            return {
                sliderPerView: "4",
                spaceBetween: "15",
                loop: true,
                breakpoints: {
                    320: {
                        sliderPerView: "4",
                        spaceBetween: "15",
                    }
                }
            };
        })
    },
});

let setting = {}

const openVideoModal = (code) => {
    this.$emit("openVideoModal", code);
};
const openGalleryModal = (item) => {
    this.$emit("openGalleryModal", item);
};
onMounted(() => {
    setting = props.swiperSetting
    console.log('Слайдер', props.swiperSlides)
})

</script>
